import * as React from 'react';

import { LabelContent } from './LabelContent';
import { InputError } from './InputError';
import { baseInputClasses } from './Form';

export interface Props
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  label: React.ReactNode;
  error?: string;
  hideLabel?: boolean;
}

export const Input = React.forwardRef<HTMLInputElement, Props>(
  ({ label, error, hideLabel, ...inputprops }: Props, ref) => {
    return (
      <div className="space-y-1">
        <label>
          <LabelContent hide={hideLabel}>{label}</LabelContent>
          <input
            {...inputprops}
            ref={ref}
            aria-invalid={error ? true : undefined}
            className={`${baseInputClasses(Boolean(error))} h-12 ${
              inputprops.disabled ? 'bg-grey-100' : ''
            }`}
          />
        </label>
        {error && <InputError>{error}</InputError>}
      </div>
    );
  },
);

Input.displayName = 'Input';
